var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 161,
    height: 160.75,
    rx: 5.5,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.0077 76.999V91.0048C99.0077 95.425 95.4245 99.0082 91.0043 99.0082H70.996C66.5759 99.0082 62.9927 95.425 62.9927 91.0048V70.9965C62.9927 66.5764 66.5759 62.9932 70.996 62.9932H83.001",
    stroke: "#9AA2B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9927 83.0014L65.5841 80.41C66.4888 79.5053 67.7158 78.9971 68.9952 78.9971C70.2746 78.9971 71.5016 79.5053 72.4063 80.41L81.0002 89.0039",
    stroke: "#9AA2B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0015 99.0075L83.5971 86.4119C85.4809 84.5281 88.5353 84.5281 90.4192 86.4119L98.3008 94.2936",
    stroke: "#9AA2B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0045 62.9932L88.0024 67.9952",
    stroke: "#9AA2B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0065 67.9952L93.0044 62.9932",
    stroke: "#9AA2B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0048 62.9932V72.9973",
    stroke: "#9AA2B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 161,
    height: 160.75,
    rx: 5.5,
    stroke: "#E4E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/imageUpload.229d12aad33c74a8074526fed106e104.svg";
export { ForwardRef as ReactComponent };